import { successState, SUCCESS, FAILED, failedState, loadingState } from "@grandvisionhq/state";
import { useUpload } from "@grandvisionhq/upload";
function useRxUploadStatus(scopesToCheck, hasRxUploadOption) {
  const { configs } = useUpload();
  if (!hasRxUploadOption) {
    return successState(null);
  }
  const statuses = scopesToCheck.map((s) => configs[s]?.status || "failed");
  if (statuses.every((s) => s === SUCCESS)) {
    return successState(null);
  }
  if (statuses.some((s) => s === FAILED)) {
    return failedState(new Error());
  }
  return loadingState();
}
export {
  useRxUploadStatus
};
//# sourceMappingURL=use-rx-upload-status.js.map
